import React, { Component } from 'react';
import {notify} from 'react-notify-toast';
import WaitingModal from '../../../generics/WaitingModal';

import ModalOffers from './ModalOffers';
import ModalComponents from './ModalComponents';
import ModalPhenotype from './ModalPhenotype';
import ModalAddProfile from './ModalAddProfile';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';
import {notification} from 'react-icons-kit/icomoon/notification';
import Moment from 'react-moment';

import ModalGrupoRH from '../../../offers/components/ModalGrupoRH';
import ModalUpdateRh from './ModalUpdateRh';
import ModalPhenAnti from '../modalPhenAnti';

import ModalNotes from '../../petition_register/Components/modalNotes';
import ModalSections from '../../../validation_donation/components/modalSections';
import ModalFileType from '../../../results_donation/components/modalFileType';
import moment from 'moment';
import {download2} from 'react-icons-kit/icomoon/download2';
import {history} from 'react-icons-kit/icomoon/history';
import ModalTraceability from './modalTraceability';

import Phenotypes from '../../../../assets/icons/phenotypes.svg';
import Antibodies from '../../../../assets/icons/antibodies.svg';
import {check} from 'react-icons-kit/fa/check'
import {close} from 'react-icons-kit/fa/close'
import { print } from 'react-icons-kit/fa/print';
import Drops from '../../../../assets/icons/drops.svg';
import Donation from '../../../../assets/icons/donation.svg';
import { droplet } from 'react-icons-kit/icomoon/droplet';
import { pencilSquareO } from 'react-icons-kit/fa/pencilSquareO';

var Config = require('../../../../config');
const style = {
  margin: 7,
};

class FormResults extends Component{
	constructor(props, context) {
		super(props, context);
		this.addAnaliticalTest = this.addAnaliticalTest.bind(this);
		this.existTest = this.existTest.bind(this);
		this.updateDonationNotesID = this.updateDonationNotesID.bind(this);
		this.getLabSections = this.getLabSections.bind(this);
		this.checkList = this.checkList.bind(this);
		this.setValues = this.setValues.bind(this);
		this.addAnaliticalProfile = this.addAnaliticalProfile.bind(this);
		this.openModalGrupoRH = this.openModalGrupoRH.bind(this);
		this.getfenotipoAntibody = this.getfenotipoAntibody.bind(this);
		this.removeValidation = this.removeValidation.bind(this);
		this.updateGroup = this.updateGroup.bind(this);
		this.modalUpdateRH = this.modalUpdateRH.bind(this);
		this.laboratory_print = this.laboratory_print.bind(this);
		this.saveToSample = this.saveToSample.bind(this);
		this.removeAnaliticalTest = this.removeAnaliticalTest.bind(this);
		this.openPhenAnti = this.openPhenAnti.bind(this);
		this.openModalNotes = this.openModalNotes.bind(this);
		this.openModalSections = this.openModalSections.bind(this);
		this.viewTraceability = this.viewTraceability.bind(this);
		this.goReserves = this.goReserves.bind(this);
		this.validatingResults = this.validatingResults.bind(this);

		//Definicion de variables
		this.state = { 
			lab_sections:[],
			expanded: null,
			add_test:false,
			analitical_test:[],
			analitical_test_id:"",
			new_value:"",
			other_test:[],
			data_donor:{donation:{}},
			person_group_rh:"",
			person_lectina:"",
			person_du:"",
			donation_notes_id:"", 
			option:"test",
			reject_test:[],
			analitical_profile_id:"",
			validation:"pending",

			fenotipo_donante:"",
			fenotipo_donacion:"",
			antibody_donante:"",
			antibody_donacion:"",

			rh_group:"",
			enableAntibody:false,
			sections:[],

			disableValidation:true,
			disableRemoveValidation:true,
			disableGroupRh:true,
			disablePrint:true,

			respuesta:0,
			total_validate:0,
			total_sections: 0,

			hide_g_rh_phen_anti:true,
			lectinas:[],
			has_notes:false,
			lab_show_num_value:{},
			lab_select_doc:{},
			print_info:{user:null}
		}
	}

	handleChangePanel = panel => (event, expanded) => {
		this.setState({
		  expanded: expanded ? panel : false,
		});
	};

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		this.props.onRef(this);


		var group_test_id = parseInt(this.props.match.params.group_test_id);

		var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
		var donation_id = this.props.match.params.donation_id;
		
		var validate = lab_sections.findIndex((obj => obj.validate_results === true));
		if(validate !== -1){
			this.setState({	disableValidation: false });
		}

		var remove = lab_sections.findIndex((obj => obj.remove_validation === true));
		if(remove !== -1){
			this.setState({ disableRemoveValidation: false });
		}

		var user_task = JSON.parse(sessionStorage.getItem("task_has_user_profiles"));

		user_task.map((user)=>{
			if(user.type !== undefined){
				if(user.type==='MODIFY_INIT_GROUPRH'){
					this.setState({
						disableGroupRh: false
					})
				}

				if(user.type==='PRINT_RESULTS'){
				  this.setState({
					disablePrint: false
				  })
				}

				if(user.type === "EDIT_GR_RH_PHEN_ANT_PAT"){
					this.setState({
						hide_g_rh_phen_anti: false
					})
				}
			}
		})

		this.setState({
			reject_test:[]
		})

		this.getLabSections();

		fetch(Config.default.apiGateway.URL+'health_facilities/get_criterial?hf_id='+
			sessionStorage.getItem('health_facilities_id')+'&code=LAB_SELECT_DOC',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				lab_select_doc: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=LAB_SHOW_NUM_VALUE&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				lab_show_num_value: response
			});
		})
		

		fetch(Config.default.apiGateway.URL+'analitical_test?id=0&option=for_donors', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error!', error, 'error');
			  });
			}
		})
		.then(response =>{
			this.setState({
				analitical_test: response
			})
		})

		//PERFILES ANALITICOS
		fetch(Config.default.apiGateway.URL+'analytic_profile_person?option=patients', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error!', error, 'error');
			  });
			}
		})
		.then(response =>{
			this.setState({
				analitical_profiles: response
			})
		})
	
		this.getGroupTest(group_test_id);
	
	}



	saveToSample(e){
		if (this.isValidFormTest()) {
			if(!this.existTest(this.state.analitical_test_id.toString())){
				var items = this.getResults();
				this.props.waiting.handleShow('Guardado...');
				fetch(Config.default.apiGateway.URL+'sample_results?donation_id='+this.props.match.params.donation_id, {
					  method: 'POST', // or 'PUT'
					  body: JSON.stringify([]), // data can be `string` or {object}!
					  headers: new Headers({
					  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
					  	'Accept': 'application/json',
					  	'Content-Type': 'application/json;charset=UTF-8'
					  })
				})
				.then(res => {
			      this.waiting_modal.handleClose();
			      if(res.ok){
			        return res.json();
			      }else{
			        res.text().then(function(result) {
			          swal('¡Error!', result, 'error');
			        });
			      }})
				.then(response => {
			    	if(response !== undefined){
			    		this.addAnaliticalTest(e, response.id, true);
			    	}
				});
			}
		}
	}

	getfenotipoAntibody(id, campo){
		var url = "";

		switch(campo){
			case 'fenotipo_donacion':
				url = 'phenotypes/by_type?donation_id='+id+'&type=phenotype';
				break;
			case 'fenotipo_donante':
				url = 'phenotypes/by_person?person_id='+id+'&type=phenotype';
				break;
			case 'antibody_donacion':
				url = 'phenotypes/by_type?donation_id='+id+'&type=antibody';
				break;
			case 'antibody_donante':
				url = 'phenotypes/by_person?person_id='+id+'&type=antibody';
				break;
			case 'fenotipo_muestra':
				url = 'phenotypes/by_sample?samples_id='+id+'&type=phenotype';
				break;
			case 'antibody_muestra':
				url = 'phenotypes/by_sample?samples_id='+id+'&type=antibody';
				break;
		}

		fetch(Config.default.apiGateway.URL+url, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error', error, 'error');
			  });
			}
		})
		.then(response =>{
			if(response !== undefined){
				var fenotipo = "";

				switch(campo){
					case 'fenotipo_donacion':
						response.map((f)=>{
							fenotipo += f.phenotype1+f.result+',  '
						})
						break;
					
					case 'fenotipo_donante':
					case 'fenotipo_muestra':
						response.map((f)=>{
							fenotipo += f.phenotype1+f.result+',  '
						})

						break;
					case 'antibody_donacion':
					case 'antibody_muestra':
					case 'antibody_donante':
						response.map((f)=>{
							return f.result === "1" ?
								fenotipo += f.antibody+',  '
							: null
						})
						break;
				}
				
				if(campo === 'fenotipo_muestra'){
					campo = 'fenotipo_donacion';
				}else if(campo === 'antibody_muestra'){
					campo = 'antibody_donacion';
				}

				this.setState({[campo]:fenotipo})
			}
		})
	}

	resetStyles(id){
		if(document.getElementById('analitical_test_'+id) !== null){
			document.getElementById('analitical_test_'+id).value = "";
			document.getElementById('analitical_test_'+id).disabled = false;
			document.getElementById('info_'+id).style.display = "none";
			document.getElementById('mark_'+id).style.display = "none";
			document.getElementById('delete_'+id).style.display = "none";
		}
			
	}

	getLabSections(validate = false){
		//var route = 'lab_sections?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+'&donation_id='+this.props.match.params.donation_id
		var samples_id = this.props.match.params.sample_id;
	
		var route = 'lab_sections/for_patient_results?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+
			'&petition_id='+this.props.match.params.petition_id+
			"&samples_id="+samples_id

		//lab_sections
		fetch(Config.default.apiGateway.URL+route, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error!', error, 'error');
			  });
			}
		})
		.then(response =>{
			if(response !== undefined){
				this.setState({
					lab_sections: response,
					sections:[]
				})
				setTimeout(function(){
					var num_preguntas = 0;
					
					
					response.map((item) =>{ 
						
						this.setState({
							sections: [...this.state.sections, {id:item.section.id, name:item.section.name}]
						});

						num_preguntas += item.analitical_test_list.length;

						item.analitical_test_list.map((obj) =>{ 
							
							this.resetStyles(obj.analitical_test.id)
							
							this.setValues(obj.analitical_test.id);
						
							if(obj.analitical_test.is_antibody && samples_id !== 0){
								this.props.state.results.map((r)=>{
									if(r.analitical_test_id == obj.analitical_test.id){

										var val = r.value;
									
										if(val === "POSITIVO"){
											this.setState({
												enableAntibody: true
											});
										}else{
											this.setState({enableAntibody:false});
										}
										this.showDeleteBtn(obj);
									}
								})

								this.showDeleteBtn(obj);
							}else{
								
								if(this.props.state.results !== undefined){
									
									this.showDeleteBtn(obj)
									/*this.props.state.results.map((r)=>{
										if(r.analitical_test_id == obj.analitical_test.id){}
									})*/

									if(obj.analitical_test.code === 'LEC' || obj.analitical_test.name === 'LECTINA'){
										
										var indexG_a = this.props.state.results.findIndex(res => (
											res.value === 'A'
										));

										var indexG_ab = this.props.state.results.findIndex(res => (
											res.value === 'AB'
										));

										this.setState({lectinas:obj.results});

										if(indexG_a !== -1){
											var results_lect = [];
											obj.results.map((res)=>{												
												if(res.value.length === 2 || res.code === 'NP'){
													results_lect.push(res);
												}else if(res.value.length === 1){
													results_lect.push(res);
												}

											});
											obj.results = results_lect;
										}

										if(indexG_ab !== -1){
											var results_lect = [];
											obj.results.map((res)=>{
												if(res.value.length === 3 || res.code === 'NP'){
													results_lect.push(res);
												}else if(res.value.length === 1){
													results_lect.push(res);
												}
											
											});

											obj.results = results_lect;
										}
									}
								}
									
							}
							


						})

						
					})

					
					var resultados = this.props.state.results !== undefined ? this.props.state.results.length : 0;
					var total = num_preguntas - resultados;

					if(num_preguntas !== resultados){
						this.setState({
							respuesta: total
						});
					}


					if(validate){
						setTimeout(()=>{
							this.openModalValidation();
						}, 500)
						
					}

					this.setOtherTestTable();

				}.bind(this), 2000);
			}
				
				
		})
	}

	showDeleteBtn(obj){
		var index = this.props.state.results.findIndex(r => r.analitical_test_id === obj.analitical_test.id);
		if(index !== -1){
			
			if(this.state.validation !== "ACCEPTED" && this.state.validation !== "REJECT"){
			
				if(this.props.state.results[index].option_delete){
					document.getElementById('delete_'+obj.analitical_test.id).style.display = "inline-block";
				}else {
					if(obj.required_by_validation){
						document.getElementById('delete_'+obj.analitical_test.id).style.display = "inline-block";
					}else{
						document.getElementById('delete_'+obj.analitical_test.id).style.display = "none";
					}
				}

				if(this.props.state.results[index].value !== ""){
					document.getElementById('delete_'+obj.analitical_test.id).style.display = "none";
				}
			}else{
				document.getElementById('delete_'+obj.analitical_test.id).style.display = "none";
			}

			
		}else{
			if(obj.required_by_validation){
				document.getElementById('delete_'+obj.analitical_test.id).style.display = "inline-block";
			}else{
				document.getElementById('delete_'+obj.analitical_test.id).style.display = "none";
			}
		}
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	//Evento de cambio en elementos formulario
	handleSelectChange = (event) => {
		this.setState({[event.target.name]:event.target.value});
	}

	donationNotes(e){
		e.preventDefault();
		this.modal_notes.handleShow(this.props.match.params.petition_id, );
		this.modal_notes.handleShow(
			this.state.donation_notes_id, 
			this.props.match.params.donation_id,
			this.props.match.params.sample_id,
			this.state.data_donor.donation.offers_id,
			this.state.data_donor.donor_id,
			'donation_notes'
		);
			
	}

	//Evento de cambio en elementos formulario
	handleChange = (event) => {
		this.setState({
			change_value:true
		});

		var control = document.getElementById(event.target.id);
		this.state.lab_sections.map((section)=>{
			section.analitical_test_list.map((test)=>{
				if(control.options !== undefined){
					const selectedIndex = control.options.selectedIndex;
					var text = control.options[selectedIndex].text;

					if("analitical_test_"+test.analitical_test.id === event.target.id){
						if(test.analitical_test.is_antibody){
							if(text === "POSITIVO"){
								this.setState({enableAntibody: true})
							}else{
								this.setState({enableAntibody: false})
							}
						}
					}

					
					if(test.analitical_test.code === 'LEC' || test.analitical_test.name === 'LECTINA'){
						
						if(event.target.value === 'A'){
							var results_lect = [];
							this.state.lectinas.map((res)=>{
								if(res.value.length === 2  || res.code === 'NP'){
									results_lect.push(res);
								}
							});

							test.results = results_lect;
						}else{
							test.results = this.state.lectinas;
						}

						if(event.target.value === 'AB'){
							var results_lect = [];
							this.state.lectinas.map((res)=>{
								if(res.value.length === 3  || res.code === 'NP'){
									results_lect.push(res);
								}
							});

							test.results = results_lect;
						}

						this.forceUpdate();
					}
				}else{
					if("analitical_test_"+test.analitical_test.id === event.target.id){
						control.value = event.target.value;
					}
				}
			})
		})


		if(event.target.name === "analitical_test_id" || event.target.name  === "new_value"){
			if(event.target.name === "analitical_test_id"){
				var check = this.checkList(event.target.value);
			}else{
				check = true;
			}

			if(check !== undefined){
				if(check){
					this.setState({
						[event.target.name]:event.target.value
					});
				}else{
					swal('¡Error!', 'La prueba que intenta seleccionar se encuentra en las pruebas anteriores', 'error');
					this.setState({
						[event.target.name]:""
					});
				}
			}
		}
		if(event.target.id !== null ){
			var control = document.getElementById(event.target.id);
			if(control !== null){
				if(event.target.name.indexOf('analitical_test_') !== -1){
				
					this.validateElement(control);
				}
			}
		}
	}

	validateElement(control, validate){
		if(control.options !== undefined){
			const selectedIndex = control.options.selectedIndex;

			if(selectedIndex !== -1){
				var id = parseInt(control.options[selectedIndex].getAttribute('data-key'));
				var text = control.options[selectedIndex].text;

				if(control.options[selectedIndex].getAttribute('data-key') !== null){
					this.state.lab_sections.map((section)=>{
						return section.analitical_test_list.map((test)=>{
							
							if(control.id === 'analitical_test_'+test.analitical_test.id){
								
								if(control.value !== ""){
									control.classList.remove('error')
								}

								/*test.accepted_values.some((accept)=>{
									if(test.analitical_test.is_antibody){
									
										if(text === "POSITIVO"){
										//if(accept.settled_text_at_id === id && text === "POSITIVO"){
											control.classList.add('error')
											return accept.settled_text_at_id === id;

										}else{
											control.classList.remove('error')
										}
									}else{
										if(accept.settled_text_at_id === id){
											control.classList.remove('error')
											
											
											return accept.settled_text_at_id === id;
										}else{	
											control.classList.add('error')
											
										}
										
									}
									
								})*/

								test.highlight.map((h)=>{
									var index = test.results.findIndex(obj => 
										h.settled_tex_id === obj.id && obj.id === id
									);
									if(index !== -1){
										if(h.highlight){
											control.classList.add('error');
											return false;
										}else{
											control.classList.remove('error')
										}
									}
								})

								if(test.configured_results !== null){ //quitar en caso de correccion
									if(test.configured_results.length === 0){
										document.getElementById('info_'+test.analitical_test.id).style.display = "inline-block";
										document.getElementById('mark_'+test.analitical_test.id).style.display = "none";
									}else{
										test.configured_results.some((conf)=>{
											if(conf.settled_text_at_id === id){
												if(validate){
													document.getElementById('info_'+test.analitical_test.id).style.display = "none";
													document.getElementById('mark_'+test.analitical_test.id).style.display = "inline-block";
												}else{
													document.getElementById('info_'+test.analitical_test.id).style.display = "none";
													document.getElementById('mark_'+test.analitical_test.id).style.display = "none";
												}
												return conf.settled_text_at_id === id;
											}else{
												//if(validate){
													document.getElementById('info_'+test.analitical_test.id).style.display = "inline-block";
													document.getElementById('mark_'+test.analitical_test.id).style.display = "none";
												//}
											}
										})
									}
								}
									
									
							}
						})
					})
				}else if(control.value === ""){
					control.classList.remove('error');
					var ids = control.id.split('_');
					if(document.getElementById('info_'+ids[2]) !== null){
						document.getElementById('info_'+ids[2]).style.display = "none";
					}

					if(document.getElementById('mark_'+ids[2]) !== null){
						document.getElementById('mark_'+ids[2]).style.display = "none";
					}
					
				}
			}else{
				control.value = "";
			}
				
		}else if(control.value === ""){
			control.classList.remove('error');
			var ids = control.id.split('_');
			if(document.getElementById('info_'+ids[2]) !== null){
				document.getElementById('info_'+ids[2]).style.display = "none";
			}

			if(document.getElementById('mark_'+ids[2]) !== null){
				document.getElementById('mark_'+ids[2]).style.display = "none";
			}				
		}
	}

	checkList(val){
		var select = true;
		this.state.lab_sections.map(function(lab, i){
			if(lab.analitical_test_list.length > 0){
				lab.analitical_test_list.map(function(test, j){
					if(parseInt(test.analitical_test.id) === parseInt(val)){
						select = false;
					}
				})
			}
		}.bind(this));

		return select;
	}

	//Evento para checkbox
	handleCheck = event => {
		this.setState({ 
			[event.target.name]: event.target.checked
		});
	}

	updateDonationNotesID(id){
		this.setState({donation_notes_id:id});
	}

	openModalOffers(e){
		e.preventDefault();
		this.modal_offers.handleShow(this.state.data_donor.donor_id);
	}
	openModalComponents(e){
		e.preventDefault();
		this.modal_components.handleShow(this.state.data_donor.donation.id);
	}
	openModalPhenotype(e, modal){
		e.preventDefault();
		this.modal_phenotype.handleShow(this.state.data_donor.donor_id, this.props.state.person_id, this.state.data_donor.donation.id, modal);
	}

	openModalProfile(e){
		e.preventDefault();
		let isFormValid = true;

		var isInputValid = this.showCtrlError('analitical_profile_id');
		if (isInputValid) {
			this.modal_add_profile.handleShow(this.state.analitical_profile_id);
		}else{
			swal('¡Error!', '¡Campos Incompletos', 'error');
		}
	}

	removeOtherTest = (indice) => {
		var array = [...this.state.other_test];
		array.splice(indice, 1);
		this.setState({other_test: array});
	}

	addAnaliticalTest(e, samples_id, reload) {
		if (this.isValidFormTest()) {
			if(!this.existTest(this.state.analitical_test_id.toString())){

				if(this.state.validation === 'ACCEPTED' || this.state.validation === 'REJECT'){
					swal('Error', 'La prueba no puede ser agregada.', 'error');
						
				}else{
					var obj = [{
						samples_id: samples_id,
						analitical_test_id: this.state.analitical_test_id,
						value:this.state.new_value
					}];

					this.saveAnaliticalTest(obj, samples_id, reload);
					
				}
			}else{
				swal('¡Error!', '¡Ya ha agregado esta prueba!', 'error');
			}
		} else{
			swal('¡Error!', '¡Campos Incompletos', 'error');
		}
	}

	saveAnaliticalTest(item, samples_id, reload){
		this.props.waiting.handleShow('Guardado...');
		
		fetch(Config.default.apiGateway.URL+'other_anaitical_test_required/add_test_to_sample'+
			'?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method:'post',
			body:JSON.stringify(item),
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
					
				if(reload){
					this.props.history.push("/results_donation/edit/"+samples_id+"/"+this.props.match.params.donation_id+'/0');
					//this.props.getData(samples_id);
				}else{
					
					if(response.res !== 'success'){
						swal('Alerta', 'No hubo cambio en el registro de pruebas', 'warning');
					}else{
						swal('Success', 'La prueba se registro correctamente', 'success');
					}
					this.setState({analitical_test_id:"", new_value:""});
					this.props.getData()
					this.getLabSections();
					
				}
			}
		})
	}

	removeAnaliticalTest(e,sample_id,id){
		e.preventDefault();
		swal({
			title: '¿Está seguro?',
			text: '¿Desea eliminar esta prueba?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				this.props.waiting.handleShow('Guardado...');
				fetch(Config.default.apiGateway.URL+'other_anaitical_test_required/delete_test?samples_id='+sample_id+
					'&analitical_test_id='+id, {
					method:'delete',
					headers:new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Buen Trabajo', 'Registro Eliminado','success');
						this.resetStyles(id);
						this.props.getData()
						this.getLabSections();
							
					}
					
				})

				
			}
		});
		
	}

	removeAnaliticalTestRequired(e,id){
		e.preventDefault();
		console.log('requerido');
		
		swal({
			title: '¿Está seguro?',
			text: '¿Desea eliminar esta prueba?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, (isConfirm)=> {
			if (isConfirm) {
				this.props.waiting.handleShow('Guardado...');
				fetch(Config.default.apiGateway.URL+'other_anaitical_test_required/'+id, {
					method:'delete',
					headers:new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Buen Trabajo', 'Registro Eliminado','success');
						//this.resetStyles(id);
						this.props.getData();
						this.getLabSections();
							
					}
					
				})

				
			}
		});	
	}

	addAnaliticalProfile(array_test){
		var obj = [];

		array_test.map((a)=>{
			obj.push({
				samples_id: this.props.match.params.sample_id,
				analitical_test_id:a.analitical_test.id,
				value:a.value
			})
		});

		this.saveAnaliticalTest(obj, this.props.match.params.sample_id, false);
	}

	existTest(id){
		for(var i =0; i < this.state.other_test.length;i++){
			if(this.state.other_test[i].analitical_test.id.toString() === id){
				return true;
			}
		}

		return false;
	}

	isValidFormTest(){
		let isFormValid = true;

		var isInputValid = this.showCtrlError('analitical_test_id');
		//var isInputValid = this.showCtrlError('new_value');
		if (!isInputValid) {
			isFormValid = false;
		}

		return isFormValid;
	}

	//desplegar errores en selceted
	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if(control !== null){
			if (control.value === null || control.value === "") {
			  control.classList.add('error');
			  res = false;
			} else{
			  control.classList.remove('error');
			  res = true;
			}
		}

		return res;
	}

	getResults(){
		var res = [];
		var obj = {};

		var sample_types_id = "";

		this.props.state.results.map(function(r, i){
			if(document.getElementById("analitical_test_"+r.analitical_test_id) !== null){
				obj = {};
				obj.id = r.id;
				obj.value = document.getElementById("analitical_test_"+r.analitical_test_id).value;
				obj.sample_types_id = r.sample_types_id;
				sample_types_id = r.sample_types_id;
				obj.samples_id = r.samples_id;
				obj.analitical_test_id = r.analitical_test_id;
				obj.validated = r.validated;
				//if(obj.value !== ""){
					res.push(obj);
				//}

			}
		}.bind(this));
		//Recorrer todas las pruebas y verificar que se encuentran en el arrglo
		for(var i =0; i < this.state.lab_sections.length;i++){
			var analitical_test_list = this.state.lab_sections[i].analitical_test_list;
			for(var j=0; j< analitical_test_list.length;j++){
				if(!this.existInArray(res,analitical_test_list[j].analitical_test.id)){
					obj = {};
					obj.value = document.getElementById("analitical_test_"+analitical_test_list[j].analitical_test.id).value;
					obj.sample_types_id = sample_types_id;
					obj.samples_id = parseInt(this.props.match.params.sample_id,10);
					obj.analitical_test_id = analitical_test_list[j].analitical_test.id;
					obj.validated = false;
					//if(obj.value !== ""){
						res.push(obj);
					//}

					if(analitical_test_list[j].analitical_test.is_antibody){
						var val = document.getElementById("analitical_test_"+analitical_test_list[j].analitical_test.id).value
						if(val === "POSITIVO"){
							this.setState({
								enableAntibody: true
							});
						}
					}
				}
			}
		}

	
		/*
	
		for(var x = 0; x < this.state.other_test.length; x++){
			obj = {};
			obj.value = this.state.other_test[x].value;
			if(this.props.match.params.sample_id !== undefined){
				this.props.state.results.map(function(r, i){
					if(parseInt(this.state.other_test[x].analitical_test.id) === r.analitical_test_id){
						obj.id = r.id;
						obj.sample_types_id = r.sample_types_id;
						obj.samples_id = r.samples_id;
						obj.validated = r.validated;
					}
				}.bind(this));
			}			
			
			obj.analitical_test_id = this.state.other_test[x].analitical_test.id;
			if(obj.value !== ""){
				res.push(obj);
			}
		}*/

		return res;
	}

	existInArray(array,id){
		for(var a =0; a < array.length;a++){
			if(array[a].analitical_test_id == id)
				return true;
		}

		return false;
	}
	
	
	setValues(id){
		if(this.props.match.params.sample_id !== undefined){
			var result_value = '';
			var element = '';
			//this.props.waiting.handleShow('Cargando...');
			this.props.state.results.map(function(r, i){

				if(id === r.analitical_test_id){
					
					if(r.validated){
						document.getElementById('mark_'+id).style.display = "inline-block";
						this.setState({total_validate:this.state.total_validate+1});
					}

					result_value = r.value === 'NO RESULT' ? "" : r.value;

					if(document.getElementById("analitical_test_"+id) !== null){

						document.getElementById("analitical_test_"+id).value = result_value;

						if(	this.props.state.validation !== "removed" && 
							(
								this.props.state.validation === "accepted" || 
								this.props.state.validation === 'reject' 
							) || r.validated
						  ){

							document.getElementById("analitical_test_"+id).disabled = true;
						}else if(this.props.state.validation !== "removed" && this.props.state.validation === "pending"){
							document.getElementById("analitical_test_"+id).disabled = false;
						}
						
						var control = document.getElementById("analitical_test_"+id);
						
						this.validateElement(control, r.validated);
					}

					if(this.state.reject_test.indexOf(id) === -1){
						this.state.reject_test.push(id);	
					}

					
					
				}
			}.bind(this));
				
			setTimeout(()=>{
				this.props.waiting.handleClose()
			}, 500)
			

			return result_value;
		}		
	}

	setOtherTestTable(){
		if(this.props.match.params.sample_id !== undefined){
			this.props.state.results.map(function(r, i){
				if(this.state.reject_test.indexOf(r.analitical_test_id) === -1){
					var obj = {};
					for(var i =0; i < this.state.analitical_test.length;i++){
						if(parseInt(this.state.analitical_test[i].analitical_test.id,10) === parseInt(r.analitical_test_id,10)){
							obj.analitical_test = this.state.analitical_test[i].analitical_test;
							break;
						}
					}
					obj.value = r.value;
					this.setState({ other_test: [...this.state.other_test, obj]});
				}
			}.bind(this));
		}
	}

	openModalValidation(e){
		if(e !== undefined){
			e.preventDefault();	
		}
		

		setTimeout(function(){
			var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
			var sections = [];
			var names = "";
			var total_section = "";
			
			lab_sections.map((s)=>{
				if(s.validate_results){
					var indexSection = this.state.sections.findIndex((obj => obj.id === s.lab_sections_id));
					if(indexSection !== -1){
						sections.push(s.lab_sections_id);
						names += this.state.sections[indexSection].name+', '
					}
						
				}
			})
			names = names.slice(0, (names.length - 2));

			if(this.props.state.validation === "PENDING" || this.props.state.validation === "REMOVED" || !this.props.state.validated){
				/*if(sections.length < this.state.total_sections){
					 swal({
						title: '¿Está seguro?',
						text: 'Las secciones permitidas para validar son '+names,
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#DD6B55',
						confirmButtonText: '¡Si, Validar!',
						cancelButtonText: '¡No, Cancelar!',
						closeOnConfirm: true,
						closeOnCancel: true
					}, function (isConfirm) {
						if (isConfirm) {
							this.waiting_modal.handleShow("Validando Resultados...");
							setTimeout(function(){
								this.validateSection(sections);
							}.bind(this), 1000);
						}
					}.bind(this));
				
				}else if(sections.length === this.state.total_sections){
					this.waiting_modal.handleShow("Validando Resultados...");
					setTimeout(function(){
						this.validateSection(sections);
					}.bind(this), 1000);
				}*/
				this.waiting_modal.handleShow("Validando Resultados...");
				setTimeout(function(){
					this.validateSection(sections);
				}.bind(this), 1000);
			}else{
				swal('¡Error!', '¡No hay resultados pendientes por validar!', 'error');
			}
		}.bind(this), 1000);
	}

	validateSection(sections){
		var api = 'samples/validate_sample_patients?petition_id='+this.props.match.params.petition_id+'&sample_id='+this.props.match.params.sample_id+"&health_facilities_id="+sessionStorage.getItem("health_facilities_id")
		
		fetch(Config.default.apiGateway.URL+api,{
			method :'POST',
			body:JSON.stringify(sections),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error!', error, 'error');
			  });
			}
		})
		.then(response => {
			if(response !== undefined){
				var msg = "<table class='table' style='text-align:left;'>"+
						  "<thead>"+
							"<tr>"+
							  "<th style='text-align:center'>Sección</th>"+
							  "<th style='text-align:center'>Estatus</th>"+
							  "<th style='text-align:center'>Mensaje</th>"+
							"</tr>"+
						  "</thead>"+
						  "<tbody>";
				for(var i =0;i < response.length;i++){
					msg += "<tr>"+
							  "<td>"+response[i].lab_section+"</td>"+
							  "<td>"+response[i].status.toUpperCase()+"</td>"+
							  "<td>"+response[i].message+"</td>"+
							"</tr>";
				}
				
				msg += "</tbody></table>";
				this.getLabSections();
				swal({
					title: "Proceso Realizado",
					html:true,
					text: msg,
					//customClass: 'swal-wide',
				}, function (isConfirm) {
					if (isConfirm) {
						this.props.getData()
						this.getLabSections();
					}else{
						return false;
					}
				}.bind(this));
			}
		})
	}

	openModalGrupoRH(e){
		var donor_id = this.state.data_donor.donor_id !== undefined ? this.state.data_donor.donor_id : this.props.state.sample.donor_id;
		var offers_id = this.state.data_donor.donation.offers_id !== undefined ? this.state.data_donor.donation.offers_id : 0;
		var group_test_id = parseInt(this.props.match.params.group_test_id);
	
		this.modal_grupo_rh.handleShow(donor_id, offers_id, group_test_id);
		
		//this.modal_update_rh.handleShow(donor_id, offers_id, group_test_id);
	}

	enableElements(){
		if(this.props.match.params.sample_id !== undefined){
			this.props.state.results.map(function(r, i){
				if(document.getElementById("analitical_test_"+r.analitical_test_id) !== null){
					document.getElementById("analitical_test_"+r.analitical_test_id).disabled = false;

				}
			});
		}	
	}

	openModalSections(e){
		e.preventDefault();

		var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
		var section_lab = this.state.lab_sections;
		var sections = [];
		
		lab_sections.map((s)=>{
			if(s.remove_validation){
				var index = section_lab.findIndex(obj => 
					obj.section.id === s.lab_sections_id
				);

				if(index !== -1){
					sections.push({
						check:false,
						lab_section_name:section_lab[index].section.name,
						lab_section_id:section_lab[index].section.id
					});
				}
				
			}
				
		});

		var donation_id = this.props.match.params.donation_id;
		this.modal_sections.handleShow(donation_id, sections, 'remove_lab')
	}

	removeValidation(sections){
		var api = '';
		
		if(this.props.state.sample.donation_id !== null){
			api = 'donations/remove_validation?samples_id='+this.props.match.params.sample_id+
					"&health_facilities_id="+sessionStorage.getItem("health_facilities_id")
		}else{
			api = 'samples/remove_validation?samples_id='+this.props.match.params.sample_id+
				"&health_facilities_id="+sessionStorage.getItem("health_facilities_id")+"&petition_id="+this.props.match.params.petition_id
		}


		this.waiting_modal.handleShow('Eliminando...');
		fetch(Config.default.apiGateway.URL+api, {
			method:'post',
			body:JSON.stringify(sections),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				notify.show('Validación removida correctamente.', 'success');
				setTimeout(()=>{
					this.props.getData()
					this.getLabSections();
				}, 1500);
			}
		})
	}

	getGroupTest(id){
		fetch(Config.default.apiGateway.URL+'group_test/'+id,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => {
			if(response.ok){
				return response.json();
			}else{
				response.text().then((msg)=>{
					//swal('Error', msg, 'error');
				});
			}	
		} )
		.then(response => {
			if(response !== undefined){
				var rh_group = response.RH === '' || response.RH === null ? response.group :
								response.RH === 'POSITIVO' ?
									response.lectina === null ?
										response.group+'+'
									: response.group+response.lectina+'+' 
								: response.lectina === null ?
									response.group+'-'
								: response.group+response.lectina+'-'

				this.setState({
					rh_group: rh_group
				});
			}
				
			
		})
	}

	updateGroup(rh){
		if(JSON.stringify(this.state.data_donor.donation) !== '{}'){
			this.setState({
				rh_group: rh
			});
		}else{
			this.setState({
				person_group_rh: rh
			});
		}
		
	}

	validateInput(e) {
		const re = /^[-+]?$/;
		if (e.key === "Enter") {
			e.preventDefault(); // Prevent form submission if button present
			
			const form = e.target.form;
			const index = Array.prototype.indexOf.call(form, e.target);

			if(form.elements[index + 1] !== undefined){
				if(form.elements[index + 1].getAttribute("disabled") !== undefined){
					if(form.elements[index + 1].getAttribute("name") !== null){
						if(form.elements[index + 1].getAttribute("disabled") === null)
							form.elements[index + 1].focus();
					
						else if(form.elements[index + 1].getAttribute("disabled") === "")
							form.elements[index + 2].focus();
					}else{
						form.elements[index + 2].focus();
						
					}
				}
			}
		
			if (!re.test(e.key)) {
			  e.preventDefault();
			}
		}
	}

	modalUpdateRH(){
		var person = this.state.data_donor.person_id !== undefined ? this.state.data_donor.person_id : this.props.state.person_id;
		this.modal_update_rh.handleShow(person);
	}

	async laboratory_print(e, file_type = 'lab_results_patients', ids = []){
		e.preventDefault();

		this.waiting_modal.handleShow('Imprimiendo...');
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.props.match.params.sample_id;
		obj.file_type = file_type;
		obj.nEtiqueta = [0];
		if(file_type === 'lab_results_patients'){
			if(this.state.lab_select_doc.value !== 'NO'){
				obj.option = 'filter';	
			}
			
		}else{
			obj.ids = ids;
		}

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}
		
		if(document !== undefined){
			this.waiting_modal.handleClose();
			this.setState({ show: false});
		}else{
			this.waiting_modal.handleClose();
		}
  	}

  	openPhenAnti(id, modal){
  	
  		this.modal_phen_anti.handleShow(id, modal);
  	}

  	openModalNotes(e){
		e.preventDefault();
		this.modal_notes.handleShow(this.props.match.params.petition_id, 'laboratory');
	}

	viewTraceability(e){
		e.preventDefault();

		this.modal_traceability.handleShow(this.props.match.params.petition_id);
	}

	goReserves(e){
		e.preventDefault();
		this.props.history.push('/petition_register/reserve/'+this.props.match.params.petition_id);

	}

	validatingResults(e){
		this.props.saveItem(e,true);
	}

	//Contenido del Formulario
	render(){
		const { t } = this.props;
		const { expanded } = this.state;
		var donation_id = this.props.match.params.donation_id;
		var sample_id = this.props.match.params.sample_id;

		const tooltip = (
			<Tooltip id="tooltip">
				<strong>Resultado no configurado</strong>
			</Tooltip>
		);

		return(
			<div className="col-xs-12 col-sm-offset-1 col-sm-10" style={{padding:'0px'}}>
				{/*HEADER*/}
				<div className="col-xs-3 btn-validation" >
					<button className="btn btn-success" style={
						{border:"0px",backgroundColor: this.props.state.validation === "REMOVED" ?
							"orange"
						:this.state.validation == "ACCEPTED" ? "green"
							:this.state.validation == "PENDING" ||  this.state.validation == "DISCREPANT"?"orange"
								:this.state.validation == "REJECT"?"red"
								:"orange"
							}}
						disabled type="button">
						{this.props.state.validation === "REMOVED" || this.props.state.validation === "DISCREPANT"?
							'PENDIENTE DE VALIDAR'
						: this.state.validation == "ACCEPTED" ?
							'VALIDADO' 
						: this.state.validation == "PENDING" ?
							'PENDIENTE DE VALIDAR'
						:this.state.validation == "REJECT"?"RECHAZADA":"PENDIENTE"}
					</button>
					
				</div>

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-8" style={{paddingLeft:"0"}}>
						<label>Paciente:</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{this.props.state.donor_name }
						</span>
						<span style={{color:"red", fontSize:"30px", marginLeft:"1em"}}>
							{this.state.person_group_rh}
						</span>
						<span style={{color:"red", fontSize:"14px", marginLeft:"5px"}}>
							{this.state.person_lectina !== 'NO PROCESADO' ? this.state.person_lectina : ''}
						</span>
						<span style={{color:"red", fontSize:"14px", marginLeft:"5px"}}>
							{this.state.person_du !== "" ? '('+this.state.person_du+')' : ''}
						</span>


						{!this.state.hide_g_rh_phen_anti ? 
							this.state.person_group_rh === '' ?
								<div style={{marginLeft:"10px", display:"inline"}}>
									<button className="btn btn-info" type="button" style={{position:"absolute",marginTop:"5px"}}
										onClick={this.modalUpdateRH} >
										{'Grupo & RH inicial'}
									</button>
								</div>
							: <div style={{marginLeft:"10px", display:"inline"}}>
								<button className="btn btn-info" type="button" style={{position:"absolute",marginTop:"5px"}}
									onClick={this.modalUpdateRH} >
									{ t('content.generics.buttons.edit')}
								</button>
							</div>
						:null}
					</div>
					<div className="col-xs-12 col-sm-1">
						<label>Edad:</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{this.props.state.donor_age}
						</span>
					</div>
					<div className="col-xs-12 col-sm-2">
						<button className="btn btn-info" disabled type="button">
							{this.props.state.donor_sex}
						</button>
					</div>
				</div>
	
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-6" style={{paddingLeft:"0"}}>
						<label>Fenotipos Paciente:</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{this.state.fenotipo_donante}
						</span>

						{!this.state.hide_g_rh_phen_anti ? 
							<div style={{marginLeft:"10px", display:"inline"}}>
								<button className="btn btn-info" type="button" style={{position:"absolute",marginTop:"-8px"}}
									onClick={()=>this.openPhenAnti(this.props.state.person_id, 'phenotypes')} >
									{ t('content.generics.buttons.edit')}
								</button>
							</div>
						:null}
					</div>
					<div className="col-xs-12 col-sm-6">
						<label>Fenotipos Muestra:</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{this.state.fenotipo_donacion}
						</span>
					</div>
				</div>

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-6" style={{paddingLeft:"0"}}>
						<label>Anticuerpos Paciente:</label>
						<span style={{paddingLeft:"10px", color:'red'
					}} className="theme-color">
							{this.state.antibody_donante}
						</span>
						{!this.state.hide_g_rh_phen_anti ? 
							<div style={{marginLeft:"10px", display:"inline"}}>
								<button className="btn btn-info" type="button" style={{position:"absolute",marginTop:"-8px"}}
									onClick={()=>this.openPhenAnti(this.props.state.person_id, 'antibodies')} >
									{ t('content.generics.buttons.edit')}
								</button>
							</div>
						:null}
					</div>
					<div className="col-xs-12 col-sm-6">
						<label>Anticuerpos Muestra:</label>
						<span style={{paddingLeft:"10px", color:'red'}} className="theme-color">
							{this.state.antibody_donacion}
						</span>
					</div>							
				</div>
					
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-6" style={{paddingLeft:"0"}}>
						<label>Muestra No:</label>
						<span style={{paddingLeft:"10px"}} className="theme-color">
							{this.props.state.sample.number}
							{', '} 
							<Moment format={'DD/MM/YYYY HH:mm'}>
								{this.props.state.sample.timestamp}
							</Moment>{' '}
							{this.state.data_donor.donation.timestamp_hour!==null && this.state.data_donor.donation.timestamp_hour !== undefined?
								<Moment parse="HH:mm" format="h:mm a">{this.state.data_donor.donation.timestamp_hour}</Moment>:null}
							{this.props.state.sample.maternal_flag?"(Muestra Materna)":""}
						</span>
					</div>
					{/*JSON.stringify(this.state.data_donor.donation) !== '{}' ?
						<div className="col-xs-12 col-sm-6">
							<label>Grupo Inverso:</label>
							<span style={{color:"red", fontSize:"24px", marginLeft:"1em"}}>
								{this.state.rh_group}
							</span>
						</div>	
							:null*/}
					{this.state.print_info.user !== null &&
						<div className="col-xs-12 col-sm-6">
							<label>impresión: </label>
							<span style={{paddingLeft:"10px"}} className="theme-color">
								{this.state.print_info.user+' - '+moment(this.state.print_info.timestamp).format('DD/MM/YYYY HH:mm')}
							</span>
						</div>
					}
					
				</div>
				{this.props.state.validation_info !== null ?
					this.props.state.validation_info.user !== undefined &&
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-6" style={{paddingLeft:"0"}}>
								<label>Validación</label>
								<span style={{paddingLeft:'10px'}} className="theme-color">
									{moment(this.props.state.validation_info.timestamp_date).format('DD/MM/YYYY')+' '+
									moment(this.props.state.validation_info.timestamp_time, 'H:mm:ss.sssssss').format('HH:mm')+' '+
									this.props.state.validation_info.user}
								</span>
							</div>
						</div>
				: null}
				
				{/*LAB SECTIONS*/}
				{
				this.state.lab_sections.map((item, index) =>{            
					return(	
					<div key={index} className="col-xs-12" style={{paddingTop:"3px"}}>
						<fieldset>
							<legend style={{fontSize:"1.5em"}}>{item.section.name}</legend> 

							<div className="col-xs-12" style={{paddingTop:"20px"}}>
								{item.show_content ?
									item.analitical_test_list.map((obj, index) =>{   
										return 	<div key={index} className="col-xs-12 col-sm-8 form-group" >
											<div className="col-xs-6"  style={{padding:'0px'}}>
												<span>{obj.analitical_test.name}:</span>
											</div>
											{obj.type !== "CUALITATIVO"?
												<div className="col-xs-3" style={{padding:"0px"}}>
													<input type="text" className="form-control" //value={this.setValues(obj.analitical_test.id)} 
														required  onChange={ this.handleChange } disabled={item.modify_permission?false:true}
														id={"analitical_test_"+obj.analitical_test.id} name={"analitical_test_"+obj.analitical_test.id} onKeyPress={(e) => this.validateInput(e)}/>
												</div>
											:<div className="col-xs-3" style={{padding:"0px"}}>
												<select className="form-control" id={"analitical_test_"+obj.analitical_test.id}
													onChange={ this.handleChange } onKeyPress={(e) => this.validateInput(e)}
													name={"analitical_test_"+obj.analitical_test.id} required 
													disabled={item.modify_permission ? false : true}>
													<option value="">Seleccionar...</option>
													{
														obj.results.map(function(t) {
														  return <option key={t.id} data-key={t.id} value={t.value} >{t.value} </option>;
														})
													}
												</select>
											</div>}
											{obj.analitical_test.show_numeric_value && this.state.lab_show_num_value.value=== 'YES' ?
												<div className="col-xs-1" style={{padding:'0', marginLeft:'8px'}}>
													<input type="number" step="0.001" className="form-control hour-input" value={obj.result !== null ? obj.result.numeric_value : ""}
														onChange={ this.handleChange } disabled	id={"analitical_numeric_"+obj.analitical_test.id} 
														name={"analitical_numeric_"+obj.analitical_test.id} 
													/>
												</div>
											:null}
											<div className="col-xs-1">
												<div id={"info_"+obj.analitical_test.id} style={{color:"rgb(163, 145, 3)", display:"none", width:"33.3%"}}>
													<OverlayTrigger placement="right" overlay={tooltip}>
														<SvgIcon icon={notification} style={{paddingTop:"3px"}}/>
													</OverlayTrigger>
												</div>

												<div id={"mark_"+obj.analitical_test.id} style={{color:"green", display:"none", width:"33.3%"}}>
													<SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
												</div>
												<div id={"delete_"+obj.analitical_test.id} style={{color:"#c60000", display:"none", width:"33.3%", cursor:"pointer"}}
													onClick={obj.required_by_validation ?
														(e)=>this.removeAnaliticalTestRequired(e, obj.required_test_id)
													: (e)=>this.removeAnaliticalTest(e, sample_id,obj.analitical_test.id)}>
													<SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
												</div>
											</div>
											{/*}
											<OverlayTrigger placement="right" overlay={tooltip}>
												<div id={"info_"+obj.analitical_test.id} className="col-xs-1"
													style={{color:"rgb(163, 145, 3)", display:"none"}}>
													<SvgIcon icon={notification} style={{paddingTop:"3px"}}/>
												</div>
											</OverlayTrigger>

											<div id={"mark_"+obj.analitical_test.id} className="col-xs-1" style={{color:"green", display:"none"}}>
												<SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
											</div>*/}
										</div>
									})
								:
									<h3 style={{color:"red", textAlign:'center'}}>{item.content_msg}</h3>
								}
						  	</div>
						</fieldset>
					</div>
					)
				})
				}
				{/*OTHER TEST*/}
				<div className="col-xs-12" style={{paddingTop:"20px"}}>
					<input className="form-check-input" type="checkbox" name="add_test" onKeyPress={(e) => this.validateInput(e)}
						value={ this.state.add_test} onChange={ this.handleCheck } style={{marginRight:'5px'}}
						/>
					<span>{t('content.results_donation.add_test')}</span>
				</div>
				{this.state.add_test?
				<div className="col-xs-12" style={{padding:"0px"}}>
					<fieldset>
						<legend style={{fontSize:"1.5em"}}>{t('content.results_donation.other_test')}</legend>
						<div className="col-xs-12" style={{paddingTop:"20px"}}>
							<div className="col-xs-12 col-sm-2">
								<span>Tipo:</span>
								<select className="form-control" onChange={ this.handleSelectChange } onKeyPress={(e) => this.validateInput(e)}
									value={ this.state.option || "" } name="option" id="option" required>
									<option key="test" value="test"> Prueba Analítica</option>
									<option key="profile" value="profile"> Perfil Analítico</option>
								</select>
							</div>
							{this.state.option == "test"?
								<div style={{padding:"0px"}}>
									<div className="col-xs-12 col-sm-4">
										<span>{t('content.results_donation.select_test')}:</span>
										<select className="form-control" onChange={ this.handleChange }
											value={ this.state.analitical_test_id || "" } onKeyPress={(e) => this.validateInput(e)}
											name="analitical_test_id" id="analitical_test_id" required>
											<option value="">Seleccionar...</option>
											{
											this.state.analitical_test.map(function(t) {
											  return <option key={t.analitical_test.id}  value={t.analitical_test.id} >{t.analitical_test.name} </option>;
											})
										}
										</select>
									</div>

									<div className="col-xs-12 col-sm-2">
										<span>{t('content.results_donation.value')}:</span>
										
										{this.state.analitical_test_id !== '' ?
											this.state.analitical_test.map(function(t, i) {
												return (t.analitical_test.id === parseInt(this.state.analitical_test_id) ?
													t.analitical_test.type !== "CUALITATIVO" ?
														<input key={i} type="number" className="form-control" onChange={ this.handleChange } onKeyPress={(e) => this.validateInput(e)} 
																	value={ this.state.new_value || "" } name="new_value" id="new_value" style={{textAlign:"right"}}/>
													
													: 	<select key={i} className="form-control" onChange={ this.handleChange }
															value={ this.state.new_value || i } onKeyPress={(e) => this.validateInput(e)}
															name="new_value" id="new_value" >
															<option value="">Seleccionar...</option>
															{t.results.map(function(r) {
																  return <option key={r.id}  value={r.value} >{r.value} </option>;
																})
															}
														</select>
												: false)
											}.bind(this))
										: <input className="form-control" disabled />
										}
									</div>
									<div className="col-xs-12 col-sm-1" style={{paddingTop:"15px"}}>
									  <FloatingActionButton className="action-btn"  mini={true}  
									  	onClick={ this.props.match.params.sample_id === undefined ?
									  				this.saveToSample
									  			: (e)=> this.addAnaliticalTest(e, this.props.match.params.sample_id, false)}
									  	>
										<ContentAdd/>
									  </FloatingActionButton>
									</div>
								</div>:
								<div style={{padding:"0px"}}>
									<div className="col-xs-12 col-sm-4">
										<span>Perfil:</span>
										<select className="form-control" onChange={ this.handleSelectChange }
											value={ this.state.analitical_profile_id || "" } onKeyPress={(e) => this.validateInput(e)}
											name="analitical_profile_id" id="analitical_profile_id" required>
											<option value="">Seleccionar...</option>
											{
											this.state.analitical_profiles.map(function(t) {
											  return <option key={t.profile.id}  value={t.profile.id} >{t.profile.name} </option>;
											})
										}
										</select>
									</div>
									<div className="col-xs-12 col-sm-1" style={{paddingTop:"15px"}}>
									  <FloatingActionButton className="action-btn"  mini={true} onClick={(e) => this.openModalProfile(e)} >
										<ContentAdd/>
									  </FloatingActionButton>
									</div>
								</div>
							}
						</div>
					</fieldset>
				</div>
				:null}
				{/*BUTTONS*/}

				<div className="col-xs-12" style={{textAlign:'center'}}>
					<button className="toolIcon"
						onClick={(e) => this.viewTraceability(e)} title="Trazabilidad">
						<SvgIcon size={40} icon={history} />
						<div className="col-xs-12">
							<span>Trazabilidad</span>
						</div>
					</button>

					{this.props.state.show_btn_reserves &&
						<button className="toolIcon"
							onClick={(e) => this.goReserves(e)} title="Reserva">
							<SvgIcon size={40} icon={download2} />
							<div className="col-xs-12">
								<span>Reservas</span>
							</div>
						</button>
					}
					
				</div>
				
				<div className="col-xs-12" style={{textAlign:'center'}}>
					<button type="button" className="btn btn-results" style={{background:'transparent'}}
						disabled={!this.props.task_lab_phenotypes.create || !this.props.task_lab_phenotypes.update}
						onClick={(e) => this.openModalPhenotype(e, 'phenotypes')}>
						<div style={{textAlign:'center'}}>
							<img src={Phenotypes} style={{width:'30%'}} />
						</div>	
						{t('content.generics.buttons.phenotypes')}
					</button>
					<button type="button" name="btnAntibodies" id="btnAntibodies" className="btn btn-results" 
						style={{background:'transparent'}}
						disabled={!this.props.task_lab_antibodies.create || !this.props.task_lab_antibodies.update ?
								true
							:this.state.data_donor.donation.antibodies_required !== null && 
							 this.state.data_donor.donation.antibodies_required !== undefined ? 
									this.state.data_donor.donation.antibodies_required ?
										false
									: !this.state.enableAntibody
								: !this.state.enableAntibody
							}
						onClick={(e) => this.openModalPhenotype(e, 'antibodies')}>
						<div style={{textAlign:'center'}}>
							<img src={Antibodies} style={{width:'30%'}} />
						</div>	
						{t('content.generics.buttons.antibodies')}
					</button>
					{JSON.stringify(this.state.data_donor.donation) !== '{}' ?
						<button className="btn btn-results" type="button" disabled={this.state.disableGroupRh} onClick={this.openModalGrupoRH} 
							style={{background:'transparent'}}>
							<div style={{textAlign:'center'}}>
								<SvgIcon icon={droplet} style={{width:'30%'}} />
							</div>	
							G-Rh Inverso
						</button>
					:null}

					{JSON.stringify(this.state.data_donor.donation) !== '{}' ?
						<button type="button" className="btn btn-results" onClick={(e) => this.openModalComponents(e)}
							style={{background:'transparent'}}>
							<div style={{textAlign:'center'}}>
								<img src={Drops} style={{width:'30%'}} />
							</div>	
							{t('content.generics.buttons.components')}
						</button>
					:null}
					{JSON.stringify(this.state.data_donor.donation) !== '{}' ?
						<button type="button" className="btn btn-results" onClick={(e) => this.openModalOffers(e)} style={{background:'transparent'}}>
							<div style={{textAlign:'center'}}>
								<img src={Donation} style={{width:'30%'}} />
							</div>	
							{t('content.generics.buttons.offers')}
						</button>
					:null}

					<button type="button" className="btn btn-results" onClick={(e) => this.openModalNotes(e)}
						style={{background:'transparent'}}>
							<div style={{textAlign:'center'}}>
								<SvgIcon icon={pencilSquareO} size={25} />
							</div>	
						{t('content.generics.buttons.notes')}
					</button>

					<button type="button" className="btn btn-results" onClick={(e) => this.validatingResults(e)} 
						style={{background:'transparent'}}
						disabled={this.state.disableValidation ?
									this.state.disableValidation
								: this.state.respuesta > 0 ?
									false
								: this.props.state.validation === 'accepted' || this.props.state.validation === 'reject' ?
									true
								: false
								}>
						<div style={{textAlign:'center'}}>
							<SvgIcon icon={check} size={25} />
						</div>	
						{t('content.generics.buttons.validation')}
					</button>
					{/*this.props.task_validation_donation.delete ? */}
						<button type="button" tittle="" className="btn btn-results" onClick={this.openModalSections}
							style={{background:'transparent'}}
							disabled={this.state.disableRemoveValidation ? 
									this.state.disableRemoveValidation	
								: this.state.total_validate > 0 ?
									false	
								: this.props.state.validation !== '' ?
									this.props.state.validation === 'pending' || this.props.state.validation === 'removed' || this.props.validation === 'discrepant' ?
										true
									: false
								: this.state.validation === 'pending' || this.state.validation === 'removed' || this.props.validation === 'discrepant' ?
									true
								: false
								}>
								<div style={{textAlign:'center'}}>
									<SvgIcon icon={close} size={25} />
								</div>	
								{t('content.generics.buttons.validation')}
						</button>
					{/*:null*/}

					{!this.state.disablePrint ?
						<button type="button" tittle="" className="btn btn-results" 
							disabled={this.props.state.sample.historica ? true : false}
							style={{background:'transparent'}}
							onClick={(e)=>this.state.lab_select_doc.value === 'NO' ? 
								this.laboratory_print(e)
							: this.file_type_modal.handleShow()}>
							<div style={{textAlign:'center'}}>
								<SvgIcon icon={print} size={25} />
							</div>	
							Imprimir

						</button>
					: null}
						
				</div>
			
					
				{/*MODALS*/}
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalTraceability {...this.props} onRef={ref => (this.modal_traceability = ref)}/>
				<ModalFileType {...this.props} onRef={ref => (this.file_type_modal = ref)} 
					print={this.laboratory_print} sections={this.state.lab_sections} />
				<ModalGrupoRH update={this.updateGroup} {...this.props} onRef={ref => (this.modal_grupo_rh = ref)} />
				<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} patient={this.props.state.sample.patient_id} />
				<ModalPhenAnti getFenotipoDonacion={this.getfenotipoAntibody} {...this.props} onRef={ref => (this.modal_phen_anti = ref)}/>
				<ModalOffers {...this.props} onRef={ref => (this.modal_offers = ref)} />
				<ModalComponents {...this.props} onRef={ref => (this.modal_components = ref)} />
				<ModalPhenotype getFenotipoDonacion={this.getfenotipoAntibody} {...this.props} onRef={ref => (this.modal_phenotype = ref)} />
				<ModalAddProfile {...this.props} onRef={ref => (this.modal_add_profile = ref)} 
					checkList={this.checkList} existTest={this.existTest} showCtrlError = {this.showCtrlError} save={this.addAnaliticalProfile}/>
				<ModalUpdateRh update={this.updateGroup} {...this.props} onRef={ref => (this.modal_update_rh = ref)} getData={donation_id !== '0' ? this.getDataDonation : this.props.getData}
					sample={this.props.state.sample.number}
				 />
				<ModalSections {...this.props} onRef={ref => (this.modal_sections = ref)} removeValidation={this.removeValidation}/>
			</div>
		);
	}
}

export default FormResults;